const getEnvValue = (key) => { // 환경변수 가져오는 헬퍼 함수
    if (window.__ENV__ && window.__ENV__[key]) { // 런타임 환경 (production)
        return window.__ENV__[key];
    }
  
    return process.env[`REACT_APP_${key}`]; // 개발 환경 폴백
};

// 환경변수 값들
export const ENVIRONMENT = getEnvValue('ENVIRONMENT');

const API_PROTOCOL = getEnvValue('API_PROTOCOL') || 'https';
const WS_PROTOCOL = API_PROTOCOL === 'http' ? 'ws' : 'wss';

const API_SERVER = getEnvValue('API_SERVER');
const API_STAGE_SERVER = getEnvValue('API_STAGE_SERVER');

export const RAW_SERVER_URL = `${API_PROTOCOL}://${API_SERVER}`;
export const RAW_STAGE_SERVER_URL = `${API_PROTOCOL}://${API_STAGE_SERVER}`;
export const SERVER_URL = ENVIRONMENT === 'stage' ? RAW_STAGE_SERVER_URL : RAW_SERVER_URL;

export const RAW_WEBSOCKET_URL = `${WS_PROTOCOL}://${API_SERVER}/api/chat/ws`;
export const RAW_STAGE_WEBSOCKET_URL = `${WS_PROTOCOL}://${API_STAGE_SERVER}/api/chat/ws`;
export const WEBSOCKET_URL = ENVIRONMENT === 'stage' ? RAW_STAGE_WEBSOCKET_URL : RAW_WEBSOCKET_URL;